import Vue from 'vue';

export default {


  async webapp_callback (data) {

    return await fetch(Vue.prototype.$apiBase+'/account/web-callback', {
        method: 'post',
        headers: {
        'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        return response
    });   

  },
 

  async get_app_user (uid) {

    return await fetch(Vue.prototype.$apiBase+'/account/app-user', {
        method: 'post',
        headers: {
        'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            uid: uid, 
        }),
      })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        return response
    });   

  },



  async vat_check (subdomain, vatid) {

    return await fetch(Vue.prototype.$apiBase+'/account/validate-vat', {
        method: 'post',
        headers: {
        'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          subdomain: subdomain,
          vatid: vatid
        }),
      })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        return response
    });   
    
  },
 

  async calculate_price (subdomain, uid, country, account_type, coupon) {
 
    return await fetch(Vue.prototype.$apiBase+'/account/calculate-price', {
        method: 'post',
        headers: {
        'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          subdomain: subdomain,
          uid: uid,  
          country: country, 
          account_type: account_type,
          coupon: coupon,
        }),
      })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        return response
    });   
    
  },
 
  async create_customer (data) {

    return await fetch(Vue.prototype.$apiBase+'/stripe/create-customer', {
        method: 'post',
        headers: {
        'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        return response
    });   
    
  },




}
